import { IApplicationState } from '../../types/redux';

export const selectLoading = (state: IApplicationState): boolean => state.appStatus.isLoading;
